export default [
    {
        path: 'relatorio-prestacao-conta',
        component: () => import(
            /* webpackChunkName: 'transporte-paciente-relatorio-prestacao-conta' */
            '@/views/transporte-paciente/relatorio-prestacao-conta/Index'

        ),
        redirect: 'relatorio-prestacao-conta/index',
        children: [
            {
                name: 'transporte-paciente-relatorio-prestacao-conta-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'transporte-paciente-relatorio-prestacao-conta' */
                    '@/views/transporte-paciente/relatorio-prestacao-conta/List.vue'
                ),
            },
        ],
    },
]
